export { Didomi, scriptType, isEnabled } from "./Didomi"
